<template>
  <div class="price-area">
    <light-spinner v-if="loading" />
    <span v-if="!loading && !error"> {{ price }} {{ symbol }} </span>
    <span v-if="error" class="error">
      {{ $t("error") }}
    </span>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import cug from "@/services/cug";
import LightSpinner from "./shared/LightSpinner";
import VueI18n from "vue-i18n";

export default {
  name: "StagePrice",
  mixins: [LocaleMixin],
  components: { LightSpinner },
  props: {
    stageId: String
  },

  data() {
    return {
      price: "...",
      symbol: null,
      loading: true,
      error: false
    };
  },

  beforeMount() {
    this.getPrice();
  },

  methods: {
    getPrice: function() {
      cug
        .getStage({ id: this.stageId })
        .then(rep => {
          this.price = rep.data.withtax_price.amount / 100;
          this.symbol = rep.data.withtax_price.currency.symbol;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        error: "error"
      },
      fr: {
        error: "erreur"
      }
    }
  })
};
</script>

<style lang="scss">
.price-area {
  display: inline-block;
  text-align: center;
  .error {
    color: #f44336;
    font-weight: lighter;
  }
}
</style>
